import { useQuery } from '@tanstack/react-query';
import { getUserPublicDoc } from '@/services/firebaseApi';
import { AccountPublicRead } from '@/types';

interface UseUserOptions {
    enabled?: boolean;
}

const useUser = (userId?: string, options?: UseUserOptions) => {
    const {
        data: user,
        isLoading,
        error,
        refetch
    } = useQuery<AccountPublicRead>({
        queryKey: ['user', userId],
        queryFn: () => getUserPublicDoc(userId),
        enabled: !!userId && (options?.enabled !== false),
        staleTime: 5 * 60 * 1000, // 5 minutes
        gcTime: 10 * 60 * 1000, // 10 minutes
    });

    return {
        user,
        isLoading,
        error,
        refetch
    };
};

export default useUser;
